module.exports = __webpack_public_path__ + "img/error.c78abac4.png";